export const ROLE_ARTIST = "artist";
export const ROLE_COLLECTOR = "collector";
export const ROLE_GALLERIST = "gallerist";
export const ROLE_ART_PROFESSIONAL = "art-professional";
export const ROLE_ART_INSTITUTION = "art-institution";
